import axios from "axios";
const instance = axios.create({
  //baseURL: "https://cfe-w1-dev.ap-south-1.elasticbeanstalk.com/",
  baseURL: "https://www.crowdfundenergy.co/",
  // baseURL: "http://192.168.2.6:8080/",
});
export default instance;
